module.exports = "/assets/data/e4d77f72ef67f2a0482ed0edf96ce3c7-SE3.data.json";